export default __webpack_public_path__ + "images/9f653a4a38119e11638f9d07392ed7bd-share.svg";